import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

interface IContinueWithDividerProps {
  className?: string;
}

export const ContinueWithDivider = ({
  className,
}: IContinueWithDividerProps) => {
  const { t } = useTranslation("auth");

  return (
    <div
      className={cn(
        "after:border-border relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t",
        className,
      )}
      data-testid="auth-continue-with-divider"
    >
      <span className="bg-background-secondary text-foreground-secondary relative z-10 px-2">
        {t("social.divider")}
      </span>
    </div>
  );
};
